import React from 'react'
import { Link } from "react-router-dom"
import { useConfig } from 'hooks/use-config'
import { useMediaQuery } from 'hooks/use-media-query'
import { routes } from "router";
import StorboltLogo from "components/storbolt-logo";

const HeaderLogo = () => {
    const [config] = useConfig();

    const isDesktop = useMediaQuery('(min-width: 1280px)');

    return (
        // config.layout === 'horizontal' ? (
        //         <Link to={routes.Home.path} className="flex gap-2 items-center">
        //             <StorboltLogo
        //                 className="  text-default-900 h-8 w-8 [&>path:nth-child(3)]:text-background [&>path:nth-child(2)]:text-background"/>
        //             <h1 className="text-xl font-semibold text-default-900 lg:block hidden ">
        //                 Storbolt
        //             </h1>
        //         </Link>
        //     ) :
        (
            <Link to={routes.Home.path} className="flex gap-2 items-center xl:hidden">
                <StorboltLogo
                    className="  text-default-900 h-8 w-8 [&>path:nth-child(3)]:text-background [&>path:nth-child(2)]:text-background" />
                <h1 className="text-xl font-semibold text-default-900 lg:block ">
                    Storbolt
                </h1>
            </Link>
        )
    )
}

export default HeaderLogo